import { render } from "./CalMonth.vue?vue&type=template&id=0bd7348f&scoped=true"
import script from "./CalMonth.vue?vue&type=script&lang=js"
export * from "./CalMonth.vue?vue&type=script&lang=js"

import "./CalMonth.vue?vue&type=style&index=0&id=0bd7348f&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd7348f"]])

export default __exports__